import { Component, OnInit, Input, HostListener, ElementRef } from '@angular/core';
import { Slider } from './class/slider';
import { ISliderConfig } from './interface/slider-config';
import { ISlide } from './interface/slide';
export class SliderComponent implements OnInit {

   init: Slider;
public sliderItems: Array<ISlide>;
public config: ISliderConfig;
public componentWidth: number;
public currentItemIndex: number;
public activeTitle: string;
public sliderStyle: any;
public slideStyle: any;
/**
 * @param {?} el
 */
constructor(
public el: ElementRef
  ) {
    this.currentItemIndex = 0;
    this.activeTitle = '';
  }
/**
 * @return {?}
 */
ngOnInit() {
    this.sliderItems = this.init.items;
    this.config = this.init.config;
    this.setTitle();
    this.resize();
    this.setSliderStyle();
  }
/**
 * @return {?}
 */
onResize() {
    this.resize();
  }
/**
 * @return {?}
 */
private resize() {
    this.componentWidth = this.el.nativeElement.parentElement.clientWidth - (this.getPreviewWidth() * this.getNumberOfPreview());
    this.setSlideStyle();
  }
/**
 * @return {?}
 */
private setSliderStyle(): void {
    const /** @type {?} */ width = `${this.getWrapperWidth()}px`;
    const /** @type {?} */ left = this.getWrapperLeft() ? `-${this.getWrapperLeft() - this.getPreviewWidth()}px` : 0;

    this.sliderStyle = {
      width: width,
      left: left,
      transition: `left ${this.config.transitionDuration}s`
    };
  }
/**
 * @return {?}
 */
private setSlideStyle(): void {
    this.slideStyle = {
      width: `${this.componentWidth}px`
    };
  }
/**
 * @return {?}
 */
private setTitle(): void {
    this.activeTitle =
      this.sliderItems.length ? this.sliderItems[this.currentItemIndex].title : '';
  }
/**
 * @return {?}
 */
private getNumberOfPreview(): number {
    return this.config.showPreview ? this.config.numberOfPreview : 0;
  }
/**
 * @return {?}
 */
private getPreviewWidth(): number {
    return this.config.showPreview ? this.config.previewWidth : 0;
  }
/**
 * @return {?}
 */
private getWrapperWidth(): number {
    return this.sliderItems.length ? this.sliderItems.length * this.componentWidth : this.componentWidth;
  }
/**
 * @return {?}
 */
private getWrapperLeft(): number {
    return this.currentItemIndex * this.componentWidth;
  }
/**
 * @param {?} action
 * @return {?}
 */
private goTo(action: any): void {
    if (action === 'next') {
      if (this.sliderItems.length - 1 > this.currentItemIndex) {
        this.currentItemIndex++;
      } else {
        this.currentItemIndex = this.config.loop ? 0 : this.currentItemIndex;
      }
    } else if (action === 'previous') {
      if (this.currentItemIndex > 0) {
        this.currentItemIndex--;
      } else {
        this.currentItemIndex = this.config.loop ? this.sliderItems.length - 1 : this.currentItemIndex;
      }
    } else {
      this.currentItemIndex = action;
    }
    this.setSliderStyle();
    this.setTitle();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  // tslint:disable-next-line:component-selector
  selector: 'ngx-slider',
  template: `
    <h4 *ngIf="config.showTitle" class="slide-title" [innerHTML]="activeTitle"></h4>
    <div class="slider-container">
      <div class="slider-row">
        <div [ngStyle]="sliderStyle" class="slide-wrapper">
          <div *ngFor="let slide of sliderItems; let i=index;" 
               [class.active]="i === currentItemIndex"
               [ngStyle]="slideStyle" 
               class="slide-item">
               <div [ngStyle]="{'background-image': 'url(' + slide.src + ')'}" class="slide"></div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="sliderItems.length > 1 && config.showNavigator">
          <button (click)="goTo('next')" class="slider-nav next">
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
            <button (click)="goTo('previous')" class="slider-nav previous">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
            </button>
      </ng-container>
      <div *ngIf="sliderItems.length > 1 && config.showDots" class="slider-dots">
        <ul>
          <li *ngFor="let slide of sliderItems; let i=index;" [class.active]="i === currentItemIndex">
            <button (click)="goTo(i)" class="dots">
              <i class="fa fa-circle" aria-hidden="true"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  `,
  styles: [`
    .slider-container {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
    }
    .slider-row {
        width: 100%;
        height: 100%;
    }
    .slide-wrapper {
        position: absolute;
        height: 100%;
    }
    .slide-wrapper .active {
        opacity: 1;
        -webkit-transition: opacity 1s, -webkit-transform 1s;
        transition: opacity 1s, -webkit-transform 1s;
        transition: opacity 1s, transform 1s;
        transition: opacity 1s, transform 1s, -webkit-transform 1s;
    }
    .slide-item {
        display: inline-block;
        height: 100%;
        opacity: 0.5;
        -webkit-transition: opacity 1s, -webkit-transform 1s;
        transition: opacity 1s, -webkit-transform 1s;
        transition: opacity 1s, transform 1s;
        transition: opacity 1s, transform 1s, -webkit-transform 1s;
    }
    .slide {
        height: 100%;
        background-repeat: no-repeat;
        background-size: auto;
        background-position: center;
        margin: 0 5px;
    }
    .slide-title {
        font-size: 1.5rem;
        padding: 10px;
    }
    .slider-nav {
        background-color: rgba(0,0,0,0.2);
        position: absolute;
        top: 35%;
        border: none;
        -webkit-box-shadow: none;
                box-shadow: none;
        color: white;
        font-size: 2rem;
        padding: 1.5rem;
    }

    .next {
        right: 0;
    }

    .previous {
        left: 0;
    }

    .slider-dots {
        position: absolute;
        bottom: 3%;
        width: 100%;
        text-align: center;
    }

    .slider-dots ul {
        margin: 0;
        padding: 0;
    }

    .slider-dots ul li {
        display: inline-block;
        list-style: none;
        margin: 0 3px;
    } 

    .slider-dots ul li.active i {
        color: #00C24F;
    }

    .dots {
        padding: 0;
        border: 0;
        -webkit-box-shadow: none;
                box-shadow: none;
        background: none;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'init': [{ type: Input },],
'onResize': [{ type: HostListener, args: ['window:resize', ['$event.target'], ] },],
};
}

function SliderComponent_tsickle_Closure_declarations() {
/** @type {?} */
SliderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SliderComponent.ctorParameters;
/** @type {?} */
SliderComponent.propDecorators;
/** @type {?} */
SliderComponent.prototype.init;
/** @type {?} */
SliderComponent.prototype.sliderItems;
/** @type {?} */
SliderComponent.prototype.config;
/** @type {?} */
SliderComponent.prototype.componentWidth;
/** @type {?} */
SliderComponent.prototype.currentItemIndex;
/** @type {?} */
SliderComponent.prototype.activeTitle;
/** @type {?} */
SliderComponent.prototype.sliderStyle;
/** @type {?} */
SliderComponent.prototype.slideStyle;
/** @type {?} */
SliderComponent.prototype.el;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
